<template>
  <div>
    <v-container :class="ui.bkgdColor">
      <div class="mt-4">
        <div v-if="
        this.getDetailSelect.cauth !== null &&
        this.getDetailSelect.cdid !== '' &&
        this.getDetailSelect.cdid !== null">
          <v-layout row class="mr-4 ml-1">
            <v-flex xs10 offset-xs2>
              <v-layout row>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon>account_balance</v-icon>
                  </v-avatar>
                  Company Access
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
                v-if="this.getDetailBasic.lock === false">
                  <v-avatar>
                  <v-icon>vpn_key</v-icon>
                  </v-avatar>
                  {{ this.getDetailSelect.cauth }}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
                v-else>
                  <v-avatar>
                  <v-icon :color="ui.colorWarning">lock</v-icon>
                  </v-avatar>
                  {{ this.getDetailSelect.cauth }}
                </v-chip>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout row class="mr-4 ml-1"
          v-if="this.level > 1">
            <v-flex xs10 offset-xs2>
              <v-layout row>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon :color="ui.colorWarning">manage_accounts</v-icon>
                  </v-avatar>
                  <div :class="ui.textSubheadingBoldWarning">
                    New Company Access
                  </div>
                </v-chip>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout row class="ml-3 mr-4 mt-0 mb-4">
            <v-flex xs10 offset-xs2>
              <v-layout class="mr-2 mt-2">
                <div :class="ui.textSubheading"
                v-if="this.getDetailSelect !== null && this.getDetailSelect !== undefined">
                  {{defineAccess("C1", this.getDetailSelect.cauth).title}}
                </div>
              </v-layout>
              <v-layout class="mr-2 mt-1">
                <div :class="ui.textSubheading">
                  {{defineAccess("C1", this.getDetailSelect.cauth).txt}}
                </div>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="
        this.getDetailSelect.fdid !== '' &&
        this.getDetailSelect.fdid !== null">
          <v-layout row class="mr-4 ml-1 mt-2">
            <v-flex xs10 offset-xs2>
              <v-layout row>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon>place</v-icon>
                  </v-avatar>
                  Facility Access
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
                v-if="this.getDetailBasic.lock === false">
                  <v-avatar>
                  <v-icon>key</v-icon>
                  </v-avatar>
                  {{ this.getDetailSelect.fauth }}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
                v-else>
                  <v-avatar>
                  <v-icon :color="ui.colorWarning">lock</v-icon>
                  </v-avatar>
                  {{ this.getDetailSelect.fauth }}
                </v-chip>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout row class="mr-4 ml-1"
          v-if="this.level > 1">
            <v-flex xs10 offset-xs2>
              <v-layout row>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon :color="ui.colorWarning">manage_accounts</v-icon>
                  </v-avatar>
                  <div :class="ui.textSubheadingBoldWarning">
                    New Facility Access
                  </div>
                </v-chip>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout row class="ml-1 mr-4 mt-0 mb-4">
            <v-flex xs10 offset-xs2>
              <v-layout class="ml-1 mr-2 mt-2">
                <div :class="ui.textSubheading" v-if="this.getDetailSelect.fauth !== null">
                  {{defineAccess("F1", this.getDetailSelect.fauth).title}}
                </div>
              </v-layout>
              <v-layout class="ml-1 mr-2 mt-2">
                <div :class="ui.textSubheading" v-if="this.getDetailSelect.fauth !== null">
                  {{defineAccess("F1", this.getDetailSelect.fauth).txt}}
                </div>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </div>
      <v-layout row class="mb-4">
      </v-layout>
      <v-layout row class="mb-4">
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument";
import describeAccess from "@/data/describe/mixins/describeAccess";
import selectAccess from "@/data/options/mixins/selectAccess.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import transFunctions from "@/support/transitions/mixins/transFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import { mapGetters } from "vuex";
// import TransitionsStage from "@/support/transitions/components/TransitionsStage";
export default {
  data() {
    return {
      valid: true,
      level: 0,
      localForm: {
        username: "",
        useremail: "",
        objectname: "", // company or facility
        objectid: "", // company or facility
        objecticon: "",
        objecthint: "",
        objecthints: "",
        auth: "",
        authLevel: ""
      },
      orgForm: {
        auth: ""
      },
      auth: ""
    };
  },
  beforeMount() {
    this.level = this.getTransitions.level;
  },
  watch: {
    // whenever question changes, this function will run
    auth() {
      this.localForm.auth = this.auth;
      this.updateFormAuth();
    }
  },
  mixins: [
    apptheme,
    numberFunctions,
    describeDocument,
    describeAccess,
    selectAccess,
    docRevsModFunctions,
    transFunctions,
    displayFunctions
  ],
  computed: {
    ...mapGetters(["getDetailBasic", "getDetailSelect", "getTransitions"])
  }
};
</script>
